/** wa-account-v2 local dev runs with SSL (`npm run start-dv` → https://localhost:4200). */
export function normalizeAuthAppUrl(raw: string | null | undefined): string {
  const trimmed = String(raw ?? '').trim().replace(/\/+$/, '');
  if (!trimmed) {
    return '';
  }
  try {
    const url = new URL(trimmed);
    if (
      url.protocol === 'http:' &&
      (url.hostname === 'localhost' || url.hostname === '127.0.0.1') &&
      url.port === '4200'
    ) {
      url.protocol = 'https:';
      return url.origin;
    }
  } catch {
    // fall through
  }
  return trimmed;
}
